/* Energy Unleashed — collection-page bundle builder + quick add.
 *
 * Two jobs, one file, because they share the tray:
 *
 *   QUICK ADD   the labelled button on every card. Adds one tin, updates the
 *               header count, and — for a bundle-eligible tin — offers, in the
 *               tray, to make it the first tin of a bundle. It does NOT open the
 *               cart drawer: a person quick-adding from a grid is still
 *               shopping, and the drawer (or worse, /cart) pulls them out of it.
 *
 *   BUILDER     the bar, the per-card pick control and the tray arithmetic.
 *               All views onto the one draft in eu-bundle-draft.js, which the
 *               product page's quantity break reads too.
 *
 * WHY THE CARD CONTROLS ARE RENDERED IN LIQUID AND ONLY REVEALED HERE
 * Collections use infinite scroll. Anything injected by JS has to be
 * re-injected for every page of products that arrives. eu-card-info renders
 * both the add form and the pick control on every card up front, CSS decides
 * which is visible, and this file only ever paints numbers into them. Taps are
 * handled by delegated listeners for the same reason.
 *
 * QUICK ADD DOES NOT USE HORIZON'S product-form-component
 * Its form posted natively on at least one phone before the component had
 * hydrated, which is how a tap on a collection card ended up on /cart. The
 * form here is intercepted on submit; if this file is not running it still
 * posts natively — a worse experience than the intercept, but a working one.
 */
(function () {
  'use strict';
  if (window.__euQuickAddBooted) return;   // safe if loaded more than once (bar + loader)

  var D = window.EUBundleDraft;
  if (!D) return;
  window.__euQuickAddBooted = true;

  var root = document.documentElement;
  var money = D.money;
  function pp(t) { return money(D.perPouch(t)) + ' per pouch'; }
  var CART_ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');

  var bar = document.querySelector('eu-bundle-bar');
  var tray = document.querySelector('[data-eu-tray]');

  var el = {
    head: bar && bar.querySelector('[data-eu-bb-head]'),
    sub: bar && bar.querySelector('[data-eu-bb-sub]'),
    cta: bar && bar.querySelector('[data-eu-bb-cta]'),
    discard: bar && bar.querySelector('[data-eu-bb-discard]'),
    line: tray && tray.querySelector('[data-eu-tray-line]'),
    warn: tray && tray.querySelector('[data-eu-tray-warn]'),
    tiers: tray && tray.querySelector('[data-eu-tray-tiers]'),
    buildActs: tray && tray.querySelector('[data-eu-tray-build-acts]'),
    nudgeActs: tray && tray.querySelector('[data-eu-tray-nudge-acts]'),
    clear: tray && tray.querySelector('[data-eu-tray-clear]'),
    add: tray && tray.querySelector('[data-eu-tray-add]'),
    bar: tray && tray.querySelector('[data-eu-tray-bar]'),
    later: tray && tray.querySelector('[data-eu-tray-later]'),
    viewCart: tray && tray.querySelector('[data-eu-tray-cart]'),
    bundle: tray && tray.querySelector('[data-eu-tray-bundle]')
  };

  /* ================================================================ helpers */

  function cartJson(path, body) {
    return fetch(CART_ROOT + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: body
        ? { 'Content-Type': 'application/json', Accept: 'application/json' }
        : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || ('HTTP ' + r.status));
        return j;
      });
    });
  }

  /* The header bubble normally listens for Horizon's cart event, which also
   * opens the drawer. Painting the count directly keeps the drawer shut. */
  function setBubble(count) {
    var icon = document.querySelector('cart-icon');
    if (icon && typeof icon.renderCartBubble === 'function') {
      try { icon.renderCartBubble(count); } catch (e) {}
    }
  }

  var ss = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };

  /* Open our cart drawer if it is on the page, otherwise fall back to /cart. */
  function openCart() {
    if (window.EUCart && window.EUCart.refresh) {
      window.EUCart.refresh().then(function () { window.EUCart.open && window.EUCart.open(); });
    } else {
      window.location.href = CART_ROOT + 'cart';
    }
  }

  /* ============================================================ quick add ==
   * The tray reflects loose single tins actually in the CART, read back from
   * cart.js — not a session list. Reading the cart is what makes the tray show
   * on every surface (the old session-list path silently missed on desktop) and
   * is what lets "Start building" pick up a tin that was quick-added moments
   * earlier. A loose single tin is any line at the single-tin price with none of
   * our bundle/reward/protection markers. */
  function uuid() {
    var c = window.crypto;
    if (c && typeof c.randomUUID === 'function') return c.randomUUID();
    return 'eu-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  /* ---- the auto-bundle ------------------------------------------------------
   * Quick-add tins are marked `_eu_qa` and grow ONE bundle in the cart. The
   * group always holds the largest tier that fits (3/5/10); any remainder sits
   * loose at full price, so the cart total is monotonic and never spikes. The
   * only cart write is at a tier crossing: when the count hits exactly 3, 5 or
   * 10, every loose _eu_qa tin is absorbed into the group. Between tiers the
   * new tin is simply left loose. Off-tier groups draw no discount, so this is
   * always the cheapest single-bundle arrangement and never over-discounts. */
  var qa = { tins: 0, grouped: 0, gid: null };
  function looseCount() { return qa.tins; }      // the tray's "N selected"

  function computeQa(cart) {
    /* Counts EVERY standard-priced tin, not just quick-added (_eu_qa) ones.
     * The tag-only count let mixed carts sit one short of a tier forever: a
     * tin added from the product page or the drawer's picker was invisible
     * here, so ten real tins never formed the ten-bundle (QA, 2026-08-29).
     *
     * Guard: if the cart holds MORE THAN ONE bundle group, the arrangement is
     * deliberate (drawer-built packs) and absorbing loose tins into one of
     * them could push a priced group off-tier — stand down entirely. */
    var tins = 0, grouped = 0, gid = null, gids = {};
    (cart.items || []).forEach(function (l) {
      var pr = l.properties || {};
      if (l.price !== D.TIN || pr._reward || pr._protection) return;
      if (pr._bundle_id) gids[pr._bundle_id] = true;
    });
    if (Object.keys(gids).length > 1) {
      qa = { tins: 0, grouped: 0, gid: null };
      setBubble(cart.item_count || 0);
      return qa;
    }
    (cart.items || []).forEach(function (l) {
      var pr = l.properties || {};
      if (l.price !== D.TIN || pr._reward || pr._protection) return;
      tins += l.quantity;
      if (pr._bundle_id) { grouped += l.quantity; gid = pr._bundle_id; }
    });
    qa = { tins: tins, grouped: grouped, gid: gid };
    setBubble(cart.item_count || 0);
    return qa;
  }

  function refreshQa() {
    return cartJson('cart.js').then(computeQa).catch(function () { return qa; });
  }

  /* Absorb every loose _eu_qa tin into one group — called only when the count
   * has just reached an exact tier, so absorbing all loose lands the group on
   * that tier. One change.js per line with a re-read between, because changing
   * a line's properties changes its key. */
  function absorbToGroup(gid, tier) {
    var guard = 0;
    function pass() {
      return cartJson('cart.js').then(function (cart) {
        var loose = (cart.items || []).filter(function (l) {
          var pr = l.properties || {};
          return l.price === D.TIN && !pr._bundle_id && !pr._reward && !pr._protection;
        })[0];
        if (!loose || ++guard > 30) return refreshQa();
        var props = {};
        Object.keys(loose.properties || {}).forEach(function (k) { props[k] = loose.properties[k]; });
        props._eu_qa = 'true';
        props._bundle_id = gid;
        props._bundle_tier = String(tier);
        props.Bundle = tier + ' Tin' + (tier === 1 ? '' : 's');
        return cartJson('cart/change.js', { id: loose.key, quantity: loose.quantity, properties: props }).then(pass);
      });
    }
    return pass();
  }

  /* Adds that happen outside quick-add (product page, the drawer's own
   * pickers) never used to reach reconcileAuto, so a cart could sit at ten
   * tins without forming the ten-bundle. The drawer announces every cart
   * change with eu:cart-updated; reconcile on it, guarded against re-entry
   * because absorbing dispatches further updates of its own. */
  var euReconciling = false;
  document.addEventListener('eu:cart-updated', function () {
    if (euReconciling) return;
    euReconciling = true;
    reconcileAuto()
      .then(function () { euReconciling = false; }, function () { euReconciling = false; });
  });

  /* After a quick-add: group the tins if the count just hit a tier. */
  function reconcileAuto() {
    return refreshQa().then(function (st) {
      if (!D.TIERS[st.tins]) return st;          // not on a tier -> leave the new tin loose
      if (st.grouped === st.tins) return st;      // already fully grouped
      return absorbToGroup(st.gid || uuid(), st.tins);
    });
  }

  var nudgeDismissed = false;

  /* One segment per tin in the target, filled left to right — mirrors the
   * quantity-break progress on the product page, rather than one long bar. */
  function paintSegments(filled, total) {
    if (!el.bar) return;
    var html = '';
    for (var i = 0; i < total; i++) html += '<span class="eu-tray__seg' + (i < filled ? ' on' : '') + '"></span>';
    el.bar.innerHTML = html;
  }

  function quickAdd(form) {
    if (form.getAttribute('data-state') === 'adding') return;
    var id = parseInt(form.getAttribute('data-eu-qa'), 10);
    var isTin = form.hasAttribute('data-eu-qa-tin');
    var label = form.querySelector('[data-eu-qa-label]');
    var idle = label ? label.textContent : '';

    form.setAttribute('data-state', 'adding');
    if (label) label.textContent = 'Adding…';

    cartJson('cart/add.js', { items: [{ id: id, quantity: 1, properties: isTin ? { _eu_qa: 'true' } : {} }] })
      .then(function () { return isTin ? reconcileAuto() : cartJson('cart.js').then(function (c) { setBubble(c.item_count || 0); }); })
      .then(function () {
        form.setAttribute('data-state', 'added');
        if (label) label.textContent = 'Added ✓';
        setTimeout(function () {
          form.removeAttribute('data-state');
          if (label) label.textContent = idle;
        }, 1400);

        if (isTin) { nudgeDismissed = false; paint(); }
      })
      .catch(function (e) {
        form.setAttribute('data-state', 'error');
        if (label) label.textContent = 'Try again';
        setTimeout(function () {
          form.removeAttribute('data-state');
          if (label) label.textContent = idle;
        }, 2200);
        console.error('[eu-quick-add]', e);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form[data-eu-qa]');
    if (!form) return;
    e.preventDefault();
    quickAdd(form);
  });


  /* ============================================================== builder == */

  var COPY = {
    head: el.head ? el.head.innerHTML : '',
    sub: el.sub ? el.sub.textContent : '',
    cta: el.cta ? el.cta.textContent : ''
  };
  var DEFAULT_TIER = (bar && parseInt(bar.getAttribute('data-default-tier'), 10)) || 5;
  var MODE_KEY = 'eu:building';
  var busy = false;

  /* Build mode survives moving between collections — picking a BERSERKER and an
   * ICEBERG for the same bundle is the normal case. Session scope. */
  var building = ss.get(MODE_KEY) === '1';

  function paintBar(draft) {
    if (!bar) return;
    var n = D.filled(draft);
    if (building) {
      el.head.innerHTML = 'Building a bundle — <em>tap tins to add them</em>';
      el.sub.textContent = 'Any mix of flavours and brands counts toward the tier.';
      el.cta.textContent = 'Done';
      el.discard.hidden = false;
    } else if (draft && n > 0) {
      el.head.innerHTML = 'Bundle in progress — <em>' + n + ' of ' + draft.tier + ' chosen</em>';
      el.sub.textContent = 'Pick up where you left off, or discard it.';
      el.cta.textContent = 'Resume';
      el.discard.hidden = false;
    } else if (qa.tins > 0) {
      /* Quick-added tins are already growing a bundle in the cart, so the bar
       * stops inviting a fresh "Start building" and points at what they have.
       * "View bundle" once a real tier exists (3/5/10 grouped); "View cart"
       * while one or two loose tins are still short of the first tier. */
      var t = qa.tins, charged = D.autoPrice(t), tier = D.autoTier(t), up = D.nextTier(t);
      if (tier) {
        el.head.innerHTML = 'Bundle started — <em>' + t + ' tins &middot; ' + money(charged) + '</em>';
      } else {
        el.head.innerHTML = t + ' tin' + (t === 1 ? '' : 's') + ' in your cart — <em>' + money(charged) + '</em>';
      }
      el.sub.textContent = up
        ? ((up - t) + ' more make' + (up - t === 1 ? 's' : '') + ' a ' + up + '-pack (' + pp(up) + ').')
        : COPY.sub;
      el.cta.textContent = tier ? 'View bundle' : 'View cart';
      el.discard.hidden = true;
    } else {
      el.head.innerHTML = COPY.head;
      el.sub.textContent = COPY.sub;
      el.cta.textContent = COPY.cta;
      el.discard.hidden = true;
    }
  }

  function paintTiers(draft) {
    var current = draft ? draft.tier : DEFAULT_TIER;
    el.tiers.innerHTML = D.TIER_NS.filter(function (t) { return t > 1; }).map(function (t) {
      return '<button type="button" class="eu-tray__tier" data-eu-tier="' + t + '"' +
        ' aria-pressed="' + (t === current) + '">' + t + ' Tins &middot; ' + money(D.priceFor(t)) + '</button>';
    }).join('');
  }

  function paintBuildTray(draft) {
    var n = D.filled(draft);
    var tier = draft.tier;
    var charged = D.priceFor(n);
    var next = D.nextTier(n);

    var bits = ['<b>' + n + ' of ' + tier + '</b>'];
    if (n > 0) {
      bits.push('<span>&middot;</span>');
      bits.push('<b>' + money(charged) + '</b>');
      bits.push('<span>(' + pp(n) + ')</span>');
      if (n < tier) { bits.push('<span>&middot;</span>'); bits.push('<span>' + (tier - n) + ' more for ' + pp(tier) + '</span>'); }
      if (D.TIERS[n] && D.savedVs(n) > 0) bits.push('<em>Saving ' + money(D.savedVs(n)) + '</em>');
    } else {
      bits.push('<span>Tap any tin to start!</span>');
    }
    el.line.innerHTML = bits.join(' ');
    paintSegments(n, tier);

    /* The off-tier trap, said out loud: 4 tins bill $119.80 while 5 bill $109.95. */
    var better = n > 0 ? D.cheaperAbove(n) : null;
    el.warn.hidden = !better;
    if (better) {
      el.warn.innerHTML = n + ' tins has no bundle price: ' + better + ' tins is ' +
        money(D.priceFor(better)) + ', <b>' + money(charged - D.priceFor(better)) +
        ' less than your ' + n + '</b>.';
    }

    el.add.disabled = n < 1 || busy;
    el.add.textContent = busy ? 'Adding…'
      : n < 1 ? 'Add to cart'
      : 'Add ' + n + ' tin' + (n === 1 ? '' : 's') + ' · ' + money(charged);

    paintTiers(draft);
    el.tiers.hidden = false;
    el.buildActs.hidden = false;
    el.nudgeActs.hidden = true;
  }

  /* The nudge: n loose single tins in the cart. One button — "Build a bundle" —
   * which lifts them into the builder (with the 3/5/10 selector) rather than a
   * separate "group" step. */
  function autoPP(n) { return money(Math.round(D.autoPrice(n) / (n * D.POUCHES))) + ' per pouch'; }

  function paintNudgeTray(n) {
    var charged = D.autoPrice(n);      // what these tins actually cost in the cart now
    var tier = D.autoTier(n);          // the pack they already are (0 if under 3)
    var next = D.nextTier(n);          // the tier to upsell toward

    var bits = ['<b>' + n + ' Tin' + (n === 1 ? '' : 's') + ' Selected</b>',
                '<span>&middot;</span>', '<b>' + money(charged) + '</b>',
                '<span>(' + autoPP(n) + ')</span>'];
    if (tier && D.autoSaved(n) > 0) {
      bits.push('<em>Saving ' + money(D.autoSaved(n)) + '</em>');
    }
    if (next) {
      bits.push('<span>&middot;</span>');
      bits.push('<em>Add another ' + (next - n) + ' to make a ' + next + '-pack: ' + money(D.priceFor(next)) + ' (' + pp(next) + ')</em>');
    }
    el.line.innerHTML = bits.join(' ');
    paintSegments(n, next || n);
    el.warn.hidden = true;

    /* No "Build a bundle" step — the tins are already grouped in the cart. The
     * primary opens the cart drawer, but its label reassures the customer they
     * can check out with what they already have (the progress bar aims at the
     * NEXT tier, which otherwise reads as "not done yet"). */
    el.bundle.textContent = 'Checkout ' + n + ' Tin' + (n === 1 ? '' : 's');
    el.viewCart.hidden = true;

    el.tiers.hidden = true;
    el.buildActs.hidden = true;
    el.nudgeActs.hidden = false;
  }

  function paintTray(draft) {
    if (!tray) return;
    var showBuild = building && !!draft;
    var n = looseCount();
    var showNudge = !showBuild && !nudgeDismissed && n > 0;

    tray.hidden = !(showBuild || showNudge);
    root.classList.toggle('eu-tray-open', !tray.hidden);
    if (showBuild) paintBuildTray(draft);
    else if (showNudge) paintNudgeTray(n);
  }

  /** Quantities on the cards. Idempotent — see the observer below. */
  function repaint(draft) {
    var picks = document.querySelectorAll('[data-eu-pick]');
    for (var i = 0; i < picks.length; i++) {
      var node = picks[i];
      var q = draft ? D.countOf(node.getAttribute('data-eu-pick'), draft) : 0;
      if (node.getAttribute('data-q') === String(q)) continue;
      node.setAttribute('data-q', String(q));
      if (q > 0) {
        node.setAttribute('data-picked', '');
        node.innerHTML =
          '<button type="button" data-eu-dec aria-label="Remove one tin">&minus;</button>' +
          '<span class="eu-pick__qty">' + q + '</span>' +
          '<button type="button" data-eu-inc aria-label="Add one tin">+</button>';
      } else {
        node.removeAttribute('data-picked');
        node.innerHTML = '<button type="button" class="eu-pick__btn">Add to bundle</button>';
      }
    }
  }

  function paint() {
    var draft = D.read();
    /* The draft can vanish underneath us — committed from the product page in
     * this tab, or cleared in another. Take the mode down with it, fully. */
    if (!draft && building) {
      building = false;
      ss.set(MODE_KEY, '0');
      root.classList.remove('eu-building');
    }
    paintBar(draft);
    paintTray(draft);
    repaint(draft);
  }

  function setBuilding(on) {
    building = on;
    ss.set(MODE_KEY, on ? '1' : '0');
    root.classList.toggle('eu-building', on);
    if (on && !D.read()) D.start(DEFAULT_TIER);   // emits → paint
    else paint();
  }

  /* ---- wiring: builder controls, only where the bar exists ---------------- */
  if (bar && tray) {
    el.cta.addEventListener('click', function () {
      if (building) {
        /* "Done" is the same commit as the tray's Add to cart when the bundle
         * sits on a real tier — clicking Done on a finished bundle and having
         * nothing happen is the surprise the customer flagged. Off a tier it
         * just closes build mode (nothing valid to add yet). */
        var d = D.read();
        if (d && D.TIERS[D.filled(d)]) { commitDraft(); return; }
        setBuilding(false);
        return;
      }
      /* Not building and no curated draft to resume: if quick-adds have started
       * an auto-bundle, the button reads "View bundle"/"View cart" — open the
       * drawer rather than starting a fresh build. */
      var cur = D.read();
      if (!(cur && D.filled(cur) > 0) && qa.tins > 0) { openCart(); return; }
      setBuilding(true);
    });
    el.discard.addEventListener('click', function () { setBuilding(false); D.clear(); });
    el.clear.addEventListener('click', function () { D.reset(); });

    function commitDraft() {
      if (busy) return;
      busy = true;
      paint();
      D.commit().then(function () {
        busy = false;
        setBuilding(false);
        paint();
      }).catch(function (e) {
        busy = false;
        paint();
        el.warn.hidden = false;
        el.warn.textContent = 'Could not add that to the cart. ' + (e && e.message ? e.message : 'Try again.');
        console.error('[eu-builder] commit', e);
      });
    }
    el.add.addEventListener('click', commitDraft);

    /* nudge actions */
    el.later.addEventListener('click', function () { nudgeDismissed = true; paint(); });
    el.viewCart.addEventListener('click', openCart);
    el.bundle.addEventListener('click', openCart);

    document.addEventListener('click', function (e) {
      var tierBtn = e.target.closest && e.target.closest('[data-eu-tier]');
      if (tierBtn) {
        var to = parseInt(tierBtn.getAttribute('data-eu-tier'), 10);
        var cur = D.read();
        var have = cur ? D.filled(cur) : 0;
        /* Shrinking the tier below what is already picked throws picks away.
         * The cards un-highlight so it is visible, but it is still one tap to
         * lose work — so it asks. Growing never loses anything and never asks. */
        if (have > to) {
          var lose = have - to;
          var ok = window.confirm(
            'Switch to ' + to + ' tins? That drops ' + lose + ' of your ' + have + ' picks.'
          );
          if (!ok) return;
        }
        D.setTier(to);
        return;
      }

      var pick = e.target.closest && e.target.closest('[data-eu-pick]');
      if (!pick || !building) return;
      e.preventDefault();

      var id = pick.getAttribute('data-eu-pick');
      if (e.target.closest('[data-eu-dec]')) { D.remove(id); return; }

      var draft = D.read();
      if (draft && D.filled(draft) >= draft.tier) {
        var up = D.nextTier(draft.tier);
        if (up) D.setTier(up); else return;
      }
      D.add(id);
    });

    document.addEventListener(D.EVENT, function () { paint(); });

    /* The cart drawer edits the cart without touching the draft. It announces
     * every render so the bar and tray stay in step (e.g. emptying a bundle in
     * the drawer flips the bar back to "Start building"). */
    document.addEventListener('eu:cart-updated', function (e) {
      var c = e && e.detail;
      if (c && c.items) computeQa(c); else { refreshQa().then(paint); return; }
      paint();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) paint(); });

    /* Infinite scroll — react only to cards ARRIVING, never to our own repaint. */
    var grid = document.querySelector('.product-grid, [ref="cards"], results-list');
    if (grid && window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && (n.matches('[data-eu-pick]') || n.querySelector('[data-eu-pick]'))) {
              repaint(D.read());
              return;
            }
          }
        }
      }).observe(grid, { childList: true, subtree: true });
    }

    if (building && !D.read()) building = false;
    root.classList.toggle('eu-building', building);
    paint();
    refreshQa().then(paint);
  }
})();
